import $ from 'jquery';
import lodash from 'lodash';

const updateTextValue = ($component) => {
    const placeholder = $component.attr('data-placeholder') || 'Выбери';
    const text = [];

    $component.find('.ui-select__item--selected').each(function () {
        text.push($(this).text().trim());
    });

    const $value = $component.find('.ui-select__value');

    if (text.length > 0) {
        $component.addClass('ui-select--selected');
        $value.text(text.join(', ')).attr('title', text.join(', '));
    } else {
        $component.removeClass('ui-select--selected');
        $value.text(placeholder).attr('title', placeholder);
    }
};

const updateSelectedItems = ($component) => {
    const $control = $component.find('.ui-select__control');
    let value = $control.val();

    if (!Array.isArray(value)) {
        value = [value];
    }

    $component.find('.ui-select__item').removeClass('ui-select__item--selected');
    value.forEach(id => {
        $component.find(`.ui-select__item[data-value="${id}"]`).addClass('ui-select__item--selected');
    });
};

$('.ui-select').on('render', function () {
    updateSelectedItems($(this));
    updateTextValue($(this));
});

$('.ui-select__control').each(function () {
    const $component = $(this).parents('.ui-select');
    const $items = $component.find('.ui-select__items');
    $(this).find('option').each(function () {
        const text = $(this).text().trim();
        const value = $(this).attr('value');
        const selected = $(this).attr('selected');
        const parentId = $(this).attr('data-parent-id');

        const $item = $(`<div class="ui-select__item" data-value="${value}">${text}</div>`);
        if (selected) {
            $item.addClass('ui-select__item--selected');
        }
        if (parentId) {
            $item.attr('data-parent-id', parentId);
        }
        $items.append($item);
    });
    updateTextValue($component);
}).change(function () {
    $(this).parents('.ui-select').trigger('render');
});

$('.ui-select__inner').on('click', function (e) {
    e.stopPropagation();
    if ($(this).parent().hasClass('ui-select--opened')){
        $(this).parent().removeClass('ui-select--opened')
    }else{
        $('.ui-select').removeClass('ui-select--opened');
        $(this).parents('.ui-select')
            .addClass('ui-select--opened')
            .find('.ui-scroll').trigger('update');
    }

});

$('.ui-select__clear').click(function (e) {
    e.stopPropagation();
    $('.ui-select').removeClass('ui-select--opened');

    const $component = $(this).parents('.ui-select');
    const $control = $component.find('.ui-select__control');
    $control.val('').trigger('change');
});



$(document).on('click', '.ui-select__item', function (e) {
    e.stopPropagation();

    const $component = $(this).parents('.ui-select');
    const $control = $component.find('.ui-select__control');
    let value = $(this).attr('data-value');
    let controlValue = $control.val();

    if (Array.isArray(controlValue)) {
        $control.val(lodash.xor(controlValue, [value]));
    } else {
        $control.val(value);
        $component.removeClass('ui-select--opened');
    }
    $control.trigger('change');
});

$(document).click(function () {
    $('.ui-select').removeClass('ui-select--opened');
});

$('.ui-select--submit .ui-select__control').change(function () {
    setTimeout(() => {
        $(this).parents('form').submit();
    }, 30);
});
